import { useState, useEffect } from 'react';

const API = import.meta.env.VITE_API_URL || '/api';

export default function Analytics() {
  const [data, setData] = useState({ revenue_by_month: [], top_products: [], order_by_status: [] });
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    fetch(`${API}/get-analytics.php`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => setData(d)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const maxRev = Math.max(...(data.revenue_by_month || []).map(m => m.revenue || 0), 1);

  return (
    <div>
      <h1 style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '1.5rem', background: 'linear-gradient(135deg,#FFE082,#FF6B00)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '1.8rem' }}>📈 Analytics</h1>

      {loading ? <div style={{ textAlign: 'center', padding: '3rem', color: 'rgba(255,224,130,.4)', fontFamily: "'Cinzel',serif" }}>🌀 Loading analytics…</div> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: '1.5rem' }}>
          {/* Revenue Chart */}
          <div style={{ background: 'linear-gradient(135deg,rgba(20,4,0,.95),rgba(26,10,46,.95))', border: '1px solid rgba(255,184,0,.18)', borderRadius: 10, padding: '1.5rem', gridColumn: '1 / -1' }}>
            <h3 style={{ fontFamily: "'Cinzel',serif", fontSize: '.75rem', letterSpacing: '.2em', textTransform: 'uppercase', color: '#FFB800', marginBottom: '1.5rem' }}>Monthly Revenue</h3>
            {data.revenue_by_month?.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '2rem', color: 'rgba(255,224,130,.35)', fontFamily: "'Crimson Pro',serif", fontStyle: 'italic' }}>No revenue data available yet</div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '.6rem', height: 160 }}>
                {(data.revenue_by_month || []).map((m, i) => (
                  <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '.3rem' }}>
                    <span style={{ fontFamily: "'Cinzel',serif", fontSize: '.55rem', color: 'rgba(255,184,0,.5)' }}>₹{Math.round(m.revenue / 1000)}k</span>
                    <div style={{ width: '100%', height: Math.max(8, (m.revenue / maxRev) * 120), background: 'linear-gradient(180deg,#FFB800,#FF6B00)', borderRadius: '3px 3px 0 0', transition: 'height .5s' }} />
                    <span style={{ fontFamily: "'Cinzel',serif", fontSize: '.55rem', color: 'rgba(255,224,130,.4)' }}>{m.month}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Top Products */}
          <div style={{ background: 'linear-gradient(135deg,rgba(20,4,0,.95),rgba(26,10,46,.95))', border: '1px solid rgba(255,184,0,.18)', borderRadius: 10, padding: '1.5rem' }}>
            <h3 style={{ fontFamily: "'Cinzel',serif", fontSize: '.75rem', letterSpacing: '.2em', textTransform: 'uppercase', color: '#FFB800', marginBottom: '1.2rem' }}>🏆 Top Products</h3>
            {(data.top_products || []).length === 0 ? <div style={{ color: 'rgba(255,224,130,.35)', fontFamily: "'Crimson Pro',serif", fontStyle: 'italic', fontSize: '.85rem' }}>No data yet</div> : (
              (data.top_products || []).map((p, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '.6rem 0', borderBottom: '1px solid rgba(255,184,0,.07)' }}>
                  <div>
                    <span style={{ fontFamily: "'Cinzel',serif", fontSize: '.65rem', color: '#FFB800', marginRight: '.5rem' }}>#{i + 1}</span>
                    <span style={{ fontFamily: "'Crimson Pro',serif", fontSize: '.85rem', color: '#FFE082' }}>{p.name}</span>
                  </div>
                  <span style={{ fontFamily: "'Cinzel',serif", fontSize: '.75rem', color: '#4CAF50' }}>{p.sold} sold</span>
                </div>
              ))
            )}
          </div>

          {/* Orders by Status */}
          <div style={{ background: 'linear-gradient(135deg,rgba(20,4,0,.95),rgba(26,10,46,.95))', border: '1px solid rgba(255,184,0,.18)', borderRadius: 10, padding: '1.5rem' }}>
            <h3 style={{ fontFamily: "'Cinzel',serif", fontSize: '.75rem', letterSpacing: '.2em', textTransform: 'uppercase', color: '#FFB800', marginBottom: '1.2rem' }}>📦 Orders by Status</h3>
            {(data.order_by_status || []).length === 0 ? <div style={{ color: 'rgba(255,224,130,.35)', fontFamily: "'Crimson Pro',serif", fontStyle: 'italic', fontSize: '.85rem' }}>No data yet</div> : (
              (data.order_by_status || []).map((s, i) => {
                const col = { pending: '#FFB800', processing: '#FF6B00', shipped: '#2196F3', delivered: '#4CAF50', cancelled: '#C0392B' }[s.status] || '#888';
                return (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '.6rem 0', borderBottom: '1px solid rgba(255,184,0,.07)' }}>
                    <span style={{ fontFamily: "'Cinzel',serif", fontSize: '.7rem', textTransform: 'uppercase', letterSpacing: '.1em', color: col }}>{s.status}</span>
                    <span style={{ fontFamily: "'Cinzel',serif", fontSize: '.85rem', color: '#FFE082', fontWeight: 700 }}>{s.count}</span>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
}
